
/**
 * @param {string} path 
 * @returns {string}
 */
async function downloadPage(path){

   let result = await fetch(path, {
      headers: {
         "X-Requested-With" : "XMLHttpRequest" // Make sure it detects request.isAjax
      }
   });

   return await result.text();
}

/**
 * @param {string} path  
 * @returns {HTMLElement[]}
 */
async function downloadElements(path){
   let page = await downloadPage(path);

   let parent = document.createElement("div");

   parent.innerHTML = page;

   /** @type {HTMLElement[]} */
   let elements = [];

   for(var i = 0; i < parent.children.length; i++){
      elements.push(parent.children[i]);
   }

   return elements;
}


/**
 * @param {string} path  
 * @returns {HTMLElement}
 */
async function downloadElement(path){
   let page = await downloadPage(path);

   let parent = document.createElement("div");

   parent.innerHTML = page;

   if(parent.children.length == 0){
      throw new Error("Page is not a valid element. (" + page + ")");
   }

   if(parent.children.length > 1){
      console.warn("Template contains more than one element.");
   }
   
   return parent.children[0];
}

/**
 * @param {string} path  
 * @returns {Object}
 */
async function downloadJSON(path){
   let page = await downloadPage(path);

   return JSON.parse(page);
}

export default {
   downloadPage,
   downloadJSON,
   downloadElement,
   downloadElements,
}